import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import { 
  Button, 
  Col, 
  Form, 
  Row, 
  Spinner, 
  Table, 
  Container,
  Card,
  Badge
} from 'react-bootstrap';
// import { FaPrint, FaFileExport, FaSearch } from 'react-icons/fa';
import { Printer, FileEarmarkArrowUp, Search, Download, FileEarmarkSpreadsheet, ArrowLeft } from 'react-bootstrap-icons';
import Header from '../../layouts/Header';
import { useNavigate } from 'react-router-dom';

const DaySummaryReport = () => {

  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);
  const navigate = useNavigate();

  const accessToken = localStorage.getItem("authToken");
  const [subBtnLoading, setSubBtnLoading] = useState(false);
  const [printBtnLoading, setPrintBtnLoading] = useState(false);
  const [outlets, setOutlets] = useState([]);
  const [singleOutlet, setSingleOutlet] = useState('');
  const [selectedOutlet, setSelectedOutlet] = useState('');
  const [selectedOutletName, setSelectedOutletName] = useState('')
  const [startDate, setStartDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [CouponCodeOrders, setCouponCodeOrders] = useState([]);
  const [totalOrdersSummary, setTotalOrdersSummary] = useState({});
  const [userInfo, setuserInfo] = useState([]);
  const [clicked, setClicked] = useState(false);
  const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);

  useEffect(() => {
    const fetchOrderData = () => {
      const now = new Date();
      const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
      yesterday.setHours(23, 59, 59, 999);
      setStartDate(yesterday);
    };
    fetchOrderData();
  }, []);    

  useEffect(() => {
    getOutlets();
  }, []);

  const getOutlets = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("outlet", { headers });

      if (response?.data?.status === true) {
        const activeOutlets = response?.data?.data?.outlets.filter((active) => active?.status === "ACTIVE" || "INACTIVE");
        setOutlets(activeOutlets);
      }
    } catch (error) {
      if (error?.response) {
        let errorMessage = "";
        if (error.response?.status === 406) {
          errorMessage =
            error?.response?.data?.error?.message ||
            error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getOutletName = async (e) => {   
    const value = outlets?.filter(val => val._id === e);
    setSingleOutlet(value[0]?.name);  
  };

  const handleDownloadExcel = async () => {
    setDownloadBtnLoading(true);
    const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
    getSummary(adjustedStartDate, selectedOutlet, true);
  };

  const getSummary = async(date, outlet, download) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        
        // "content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      };
      const updatedStartDate = date ? date.toISOString().split("T")[0] : null;
      let reqBody
      if (download) {
        reqBody = {
          date: updatedStartDate,
          outlet: outlet,
          isDownload: download
        };
      } else {
        reqBody = {
          date: updatedStartDate,
          outlet: outlet
        };
      }
    
      const response = await axios.post("order/summary", reqBody, { 
        headers,
        responseType: download ? 'blob' : 'json'
      });

      if (download) {
          // Create a blob from the response data
          const blob = new Blob([response.data], { 
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          });
          
          // Create a link element
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          
          // Set the filename for the download
          const fileName = `${selectedOutletName} Day Summary Report For ${updatedStartDate}.xlsx`;
          link.download = fileName;
          
          // Append the link to the body and trigger the download
          document.body.appendChild(link);
          link.click();
          
          // Clean up
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
  
          toast.success('Excel file downloaded successfully!', {
              position: "top-right",
              autoClose: 3000,
              theme: "light"
          });
      } else {
        setTotalOrdersSummary(response?.data?.data?.totalOrdersSummary || {});
        setCouponCodeOrders(response?.data?.data?.couponCodeOrders || []);
        setuserInfo(response?.data?.data?.userInfo || {});
        if (response?.data?.status === true) {
          toast.success("Data Fetched Successfully", {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
          });
        } else if (response?.data?.status === false) {
          toast.info("No records available. Please try again later.", {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
          });
        }
      }
    } catch (error) {
      if (error?.response) {
        let errorMessage = '';
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }
  
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      }
    } finally {
      setDownloadBtnLoading(false);
      setLoading(false);
    }
  };

  const handleSubmit = async() => {
    setSubBtnLoading(true);
    setClicked(true);
    const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
    await getSummary(adjustedStartDate, selectedOutlet);
    setSubBtnLoading(false);
  };    

  const handlePrintReport = () => {
    setPrintBtnLoading(true);
    const tableContent = `
      <div style="margin: 20px;">
        <h3 style="text-align: center; margin-bottom: 20px;">DAY SUMMARY REPORT FOR - ${startDate?.toLocaleDateString("en-GB", { day: '2-digit', month: '2-digit', year: 'numeric' })} | ${singleOutlet}</h3>
        <table style="border-collapse: collapse; width: 100%;">
          <thead>
            <tr>
              <th style="border: 1px solid black; padding: 8px; text-align: left;">Sr.No</th>
              <th style="border: 1px solid black; padding: 8px; text-align: left;">PARTICULARS</th>
              <th style="border: 1px solid black; padding: 8px; text-align: center; width: 300px">VALUE</th>
            </tr>
          </thead>
          <tbody style="font-size: 14px">
            ${generatePrintRows()}
          </tbody>
        </table>
      </div>
    `;

    const printWindow = window.open("", "_blank", "width=900,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Printable Report Summary</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
            .header { text-align: center; margin-bottom: 20px; }
            .header h2 { margin: 0; font-size: 20px; }
          </style>
        </head>
        <body>
          ${tableContent}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
    setPrintBtnLoading(false);
  };

  const generatePrintRows = () => {
    const rows = [
      { label: "TOTAL ORDERS [WITH COUPONS]", value: `${totalOrdersSummary?.totalCouponOrdersCount || 0} nos` },
      { label: "TOTAL ORDERS [WITHOUT COUPONS]", value: `${totalOrdersSummary?.totalNonCouponOrdersCount || 0} nos` },
      { label: "TOTAL KIOSK ORDERS", value: `${totalOrdersSummary?.totalKioskOrdersCount || 0} nos` },
      { label: "CANCELLED ORDERS", value: `${totalOrdersSummary?.totalCancelledOrdersCount || 0} nos` },
      { label: "TOTAL NO OF ORDERS", value: `${totalOrdersSummary?.totalOrdersCount || 0} nos`, bold: true },
      { label: "TOTAL COUPON DISCOUNT AMOUNT", value: `₹. ${totalOrdersSummary?.totalCouponDiscount?.toFixed(2) || '0.00'}` },
      { label: "TOTAL KIOSK REVENUE", value: `₹. ${totalOrdersSummary?.totalKioskRevenue?.toFixed(2) || '0.00'}` },
      { label: "TOTAL TAXABLE", value: `₹. ${totalOrdersSummary?.totalRevenue?.toFixed(2) || '0.00'}`, bold: true },
      { label: "CANCELLED ORDERS AMT", value: `- ₹. ${totalOrdersSummary?.totalCancelledOrdersRevenue?.toFixed(2) || '0.00'}`, bold: true },
      { label: "TOTAL REVENUE", value: `₹. ${(totalOrdersSummary.totalRevenue - totalOrdersSummary.totalCancelledOrdersRevenue)?.toFixed(2) || '0.00'}`, bold: true },
      { label: "TOTAL TAX AMT", value: `+ ₹. ${totalOrdersSummary?.totaltotalTaxAmount?.toFixed(2) || '0.00'}`, bold: true },
      { 
        label: "GRAND TOTAL", 
        value: `₹. ${(
          (totalOrdersSummary.totalRevenue - totalOrdersSummary.totalCancelledOrdersRevenue) +
          (totalOrdersSummary.totaltotalTaxAmount || 0)
        ).toFixed(2) || '0.00'}`,
        bold: true 
      },
      { label: "TOTAL REFERRED USERS WITH ORDERS", value: `${userInfo?.totalReferredUsersWithOrders || 0} nos` },
      { label: "TOTAL DELETED USERS WITH ORDERS", value: `${userInfo?.totalDeletedUsersWithOrders || 0} nos` },
      { label: "TOTAL USERS WITH ORDERS", value: `${userInfo?.totalUsersWithOrders || 0} nos`, bold: true },
      { label: "TOTAL REFERRED USERS WITHOUT ORDERS", value: `${userInfo?.totalReferredUsersWithoutOrders || 0} nos` },
      { label: "TOTAL DELETED USERS WITHOUT ORDERS", value: `${userInfo?.totalDeletedUsersWithoutOrders || 0} nos` },
      { label: "TOTAL USERS WITHOUT ORDERS", value: `${userInfo?.totalUsersWithoutOrders || 0} nos`, bold: true },
      { label: "TOTAL USERS JOINED TODAY", value: `${userInfo?.totalUsersJoinedOnGivenDate || 0} nos`, bold: true },
    ];

    // Add coupon rows
    const couponRows = CouponCodeOrders?.map((coupon, index) => ({
      label: `COUPON CODE - ${coupon?.coupon?.couponCode || ''}`,
      value: `${coupon?.count || 0} nos | ₹. ${coupon?.totalCouponDiscount?.toFixed(2) || '0.00'}`
    }));

    return [...rows, ...couponRows].map((row, index) => `
      <tr>
        <td style="border: 1px solid black; padding: 8px;">${index + 1}</td>
        <td style="border: 1px solid black; padding: 8px; ${row.bold ? 'font-weight: 600' : ''}">${row.label}</td>
        <td style="border: 1px solid black; padding: 8px; text-align: center; ${row.bold ? 'font-weight: 600' : ''}">${row.value}</td>
      </tr>
    `).join('');
  };

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === 'dark' ? 'bg-dark text-light' : 'bg-light'}`}>
                

                <Card className="mb-4">
                    <Card.Body>
                        <Form>
                            <Row>
                                <div className="card-header bg-white border-0 py-2 d-flex justify-content-between align-items-center">
                                  <div>
                                      <h4 className="mb-0 fw-bold d-inline-block">
                                          <i className="bi bi-calendar-day me-2"></i>DAY SUMMARY REPORT - {startDate?.toLocaleDateString("en-GB", { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                      </h4>
                                  </div>
                                  <div>
                                      <Button 
                                          variant="outline-secondary" 
                                          size="sm" 
                                          onClick={() => navigate('/reports/all-reports')}
                                          className="me-3 d-flex align-items-center fw-semibold"
                                          style={{ height: '38px' }}
                                      >
                                          <ArrowLeft className="me-1" /> Back to Reports
                                      </Button>
                                  </div>
                              </div>
                                <hr />
                            </Row>

                            <div className="p-3 bg-light rounded-3">
                              <Row className="g-3">  
                                <Col md={4}>
                                    <Form.Group controlId="outletSelect">
                                        <Form.Label className="fw-semibold">
                                            <i className="bi bi-shop me-2"></i>Outlet
                                        </Form.Label>
                                        <Form.Select
                                            value={selectedOutlet}
                                            onChange={(e) => {
                                              const newOutlet = e.target.value;
                                              setSelectedOutlet(newOutlet);
                                              getOutletName(newOutlet);
                                              setSelectedOutletName(e.target.selectedOptions[0].label)
                                            }}
                                            className="border-secondary"
                                        >
                                            <option value="">All Outlets</option>
                                            {outlets.map((outlet) => (
                                            <option key={outlet._id} value={outlet._id} label={`${outlet?.name} (${outlet?.city})`}>
                                                {outlet.name}
                                            </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={2}>
                                    <Form.Group controlId="startDate">
                                        <Form.Label className="fw-semibold">
                                            <i className="bi bi-calendar me-2"></i>Date
                                        </Form.Label>
                                        <DatePicker
                                            selected={startDate}
                                            onChange={(date) => setStartDate(date)}
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText="Select Date"
                                            className="form-control border-secondary"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3} className="d-flex align-items-end">
                                    <Button
                                        variant="primary"
                                        onClick={handleSubmit}
                                        className="w-100"
                                        disabled={!selectedOutlet || subBtnLoading}
                                    >
                                    {subBtnLoading ? (
                                        <Spinner size="sm" animation="border" />
                                    ) : (
                                        "Generate Report"
                                    )}
                                    </Button>
                                </Col>

                                {/* Commented Download Excel Button */}
                                {/* <Col md={3} className="d-flex align-items-end">
                                  <Button 
                                      variant="outline-success" 
                                      onClick={handleDownloadExcel}
                                      className='w-100 fw-semibold'
                                      disabled={!clicked || downloadBtnLoading}
                                  >
                                      {downloadBtnLoading ? (
                                          <Spinner size="sm" animation="border" />
                                      ) : (
                                          <>
                                              <FileEarmarkSpreadsheet className="me-2" /> Download Excel
                                          </>
                                      )}
                                  </Button>
                                </Col> */}
                              </Row>
                            </div>
                            
                        </Form>

                        <div className='mt-4'>
                            {loading ? (
                                <div className="d-flex justify-content-center align-items-center py-5">
                                    <Spinner animation="border" variant="primary" />
                                    <span className="ms-2">Loading report data...</span>
                                </div>
                            ) : !clicked ? (
                                <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
                                    <div className="text-center">
                                        <i className="bi bi-clipboard-data fs-1 text-muted"></i>
                                        <h5 className="text-muted mt-3">
                                            Please select an outlet and date to view day summary
                                        </h5>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-responsive border rounded-3">
                                    <Table striped bordered hover className="mb-0">
                                            <thead className="bg-light">
                                            <tr>
                                                <th width="50">#</th>
                                                <th>Particulars</th>
                                                <th width="300" className="text-center">Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ReportRow index={1} label="TOTAL ORDERS [with Coupons]" 
                                                value={`${totalOrdersSummary?.totalCouponOrdersCount || 0} nos`} />
                                        
                                            <ReportRow index={2} label="TOTAL ORDERS [without Coupons]" 
                                                value={`${totalOrdersSummary?.totalNonCouponOrdersCount || 0} nos`} />
                                        
                                            <ReportRow index={3} label="TOTAL KIOSK ORDERS" 
                                                value={`${totalOrdersSummary?.totalKioskOrdersCount || 0} nos`} />
                                            
                                            <ReportRow index={4} label="CANCELLED ORDERS" 
                                                value={`${totalOrdersSummary?.totalCancelledOrdersCount || 0} nos`} danger />
                                            
                                            <ReportRow index={5} label="TOTAL NO OF ORDERS" 
                                                value={`${totalOrdersSummary?.totalOrdersCount || 0} nos`} bold success />
                                            
                                            <ReportRow index={6} label="TOTAL COUPON DISCOUNT AMT" 
                                                value={`₹. ${totalOrdersSummary?.totalCouponDiscount?.toFixed(2) || '0.00'}`} />
                                            
                                            <ReportRow index={7} label="TOTAL KIOSK REVENUE" 
                                                value={`₹. ${totalOrdersSummary?.totalKioskRevenue?.toFixed(2) || '0.00'}`} />
                                            
                                            {/* <ReportRow index={8} label="TOTAL REVENUE" 
                                                value={`₹. ${totalOrdersSummary?.totalRevenue?.toFixed(2) || '0.00'}`} bold primary /> */}

                                            <ReportRow index={8} label="TOTAL TAXABLE" 
                                                value={`₹. ${totalOrdersSummary?.totalRevenue?.toFixed(2) || '0.00'}`} bold primary />
                                            
                                            <ReportRow index={9} label="CANCELLED ORDERS AMT" 
                                                value={`- ₹. ${totalOrdersSummary?.totalCancelledOrdersRevenue?.toFixed(2) || '0.00'}`} bold danger />
                                            
                                            <ReportRow index={10} label="TOTAL REVENUE" 
                                                value={`₹. ${(totalOrdersSummary.totalRevenue - totalOrdersSummary.totalCancelledOrdersRevenue)?.toFixed(2) || '0.00'}`} bold warning />
                                            
                                            <ReportRow index={11} label="TOTAL TAX AMT" 
                                                value={`+ ₹. ${totalOrdersSummary?.totaltotalTaxAmount?.toFixed(2) || '0.00'}`} bold danger />

                                            <ReportRow
                                              index={12}
                                              label="GRAND TOTAL"
                                              value={`₹. ${(
                                                (totalOrdersSummary.totalRevenue - totalOrdersSummary.totalCancelledOrdersRevenue) +
                                                (totalOrdersSummary.totaltotalTaxAmount || 0)
                                              ).toFixed(2) || '0.00'}`}
                                              bold
                                              success
                                            />

                                            {/* <ReportRow index={10} label="GRAND TOTAL" 
                                                value={`₹. ${(totalOrdersSummary.totalRevenue - totalOrdersSummary.totalCancelledOrdersRevenue)?.toFixed(2) || '0.00'}`} bold success /> */}
                                            
                                            <ReportRow index={12} label="TOTAL REFERRED USERS WITH ORDERS" 
                                                value={`${userInfo?.totalReferredUsersWithOrders || 0} nos`} />
                                            
                                            <ReportRow index={13} label="TOTAL DELETED USERS WITH ORDERS" 
                                                value={`${userInfo?.totalDeletedUsersWithOrders || 0} nos`} />
                                            
                                            <ReportRow index={14} label="TOTAL USERS WITH ORDERS" 
                                                value={`${userInfo?.totalUsersWithOrders || 0} nos`} bold />
                                            
                                            <ReportRow index={15} label="TOTAL REFERRED USERS WITHOUT ORDERS" 
                                                value={`${userInfo?.totalReferredUsersWithoutOrders || 0} nos`} />
                                            
                                            <ReportRow index={16} label="TOTAL DELETED USERS WITHOUT ORDERS" 
                                                value={`${userInfo?.totalDeletedUsersWithoutOrders || 0} nos`} />
                                            
                                            <ReportRow index={17} label="TOTAL USERS WITHOUT ORDERS" 
                                                value={`${userInfo?.totalUsersWithoutOrders || 0} nos`} bold />
                                            
                                            <ReportRow index={18} label="TOTAL USERS JOINED TODAY" 
                                                value={`${userInfo?.totalUsersJoinedOnGivenDate || 0} nos`} bold success />

                                            {CouponCodeOrders?.map((coupon, index) => (
                                                <ReportRow 
                                                key={index}
                                                index={19 + index}
                                                label={<span>COUPON CODE - <span className="text-primary fw-semibold">{coupon?.coupon?.couponCode}</span></span>}
                                                value={`${coupon?.count || 0} nos | ₹. ${coupon?.totalCouponDiscount?.toFixed(2) || '0.00'}`}
                                                />
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </div>
                    </Card.Body>
                </Card>

                {/* <Card>
                    <Card.Body className="p-0">
                        {loading ? (
                            <div className="d-flex justify-content-center align-items-center py-5">
                                <Spinner animation="border" variant="primary" />
                                <span className="ms-2">Loading report data...</span>
                            </div>
                        ) : !clicked ? (
                            <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
                                <div className="text-center">
                                    <i className="bi bi-clipboard-data fs-1 text-muted"></i>
                                    <h5 className="text-muted mt-3">
                                        Please select an outlet and date to view day summary
                                    </h5>
                                </div>
                            </div>
                        ) : (
                            <div className="table-responsive border rounded-3">
                                <Table striped bordered hover className="mb-0">
                                        <thead className="bg-light">
                                        <tr>
                                            <th width="50">#</th>
                                            <th>Particulars</th>
                                            <th width="300" className="text-center">Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ReportRow index={1} label="TOTAL ORDERS [with Coupons]" 
                                            value={`${totalOrdersSummary?.totalCouponOrdersCount || 0} nos`} />
                                    
                                        <ReportRow index={2} label="TOTAL ORDERS [without Coupons]" 
                                            value={`${totalOrdersSummary?.totalNonCouponOrdersCount || 0} nos`} />
                                    
                                        <ReportRow index={3} label="TOTAL KIOSK ORDERS" 
                                            value={`${totalOrdersSummary?.totalKioskOrdersCount || 0} nos`} />
                                        
                                        <ReportRow index={4} label="CANCELLED ORDERS" 
                                            value={`${totalOrdersSummary?.totalCancelledOrdersCount || 0} nos`} danger />
                                        
                                        <ReportRow index={5} label="TOTAL NO OF ORDERS" 
                                            value={`${totalOrdersSummary?.totalOrdersCount || 0} nos`} bold success />
                                        
                                        <ReportRow index={6} label="TOTAL COUPON DISCOUNT AMT" 
                                            value={`₹. ${totalOrdersSummary?.totalCouponDiscount?.toFixed(2) || '0.00'}`} />
                                        
                                        <ReportRow index={7} label="TOTAL KIOSK REVENUE" 
                                            value={`₹. ${totalOrdersSummary?.totalKioskRevenue?.toFixed(2) || '0.00'}`} />
                                        
                                        <ReportRow index={8} label="TOTAL REVENUE" 
                                            value={`₹. ${totalOrdersSummary?.totalRevenue?.toFixed(2) || '0.00'}`} bold primary />
                                        
                                        <ReportRow index={9} label="CANCELLED ORDERS AMT" 
                                            value={`- ₹. ${totalOrdersSummary?.totalCancelledOrdersRevenue?.toFixed(2) || '0.00'}`} bold danger />
                                        
                                        <ReportRow index={10} label="GRAND TOTAL" 
                                            value={`₹. ${(totalOrdersSummary.totalRevenue - totalOrdersSummary.totalCancelledOrdersRevenue)?.toFixed(2) || '0.00'}`} bold success />
                                        
                                        <ReportRow index={11} label="TOTAL TAX AMT" 
                                            value={`₹. ${totalOrdersSummary?.totaltotalTaxAmount?.toFixed(2) || '0.00'}`} bold danger />
                                        
                                        <ReportRow index={12} label="TOTAL REFERRED USERS WITH ORDERS" 
                                            value={`${userInfo?.totalReferredUsersWithOrders || 0} nos`} />
                                        
                                        <ReportRow index={13} label="TOTAL DELETED USERS WITH ORDERS" 
                                            value={`${userInfo?.totalDeletedUsersWithOrders || 0} nos`} />
                                        
                                        <ReportRow index={14} label="TOTAL USERS WITH ORDERS" 
                                            value={`${userInfo?.totalUsersWithOrders || 0} nos`} bold />
                                        
                                        <ReportRow index={15} label="TOTAL REFERRED USERS WITHOUT ORDERS" 
                                            value={`${userInfo?.totalReferredUsersWithoutOrders || 0} nos`} />
                                        
                                        <ReportRow index={16} label="TOTAL DELETED USERS WITHOUT ORDERS" 
                                            value={`${userInfo?.totalDeletedUsersWithoutOrders || 0} nos`} />
                                        
                                        <ReportRow index={17} label="TOTAL USERS WITHOUT ORDERS" 
                                            value={`${userInfo?.totalUsersWithoutOrders || 0} nos`} bold />
                                        
                                        <ReportRow index={18} label="TOTAL USERS JOINED TODAY" 
                                            value={`${userInfo?.totalUsersJoinedOnGivenDate || 0} nos`} bold success />

                                        {CouponCodeOrders?.map((coupon, index) => (
                                            <ReportRow 
                                            key={index}
                                            index={19 + index}
                                            label={<span>COUPON CODE - <span className="text-primary fw-semibold">{coupon?.coupon?.couponCode}</span></span>}
                                            value={`${coupon?.count || 0} nos | ₹. ${coupon?.totalCouponDiscount?.toFixed(2) || '0.00'}`}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                    </Card.Body>
                </Card> */}
            </div>
        </React.Fragment>
        
    );
}

const ReportRow = ({ index, label, value, bold, danger, success, primary }) => {
  let textClass = '';
  if (danger) textClass = 'text-danger';
  if (success) textClass = 'text-success';
  if (primary) textClass = 'text-primary';

  return (
    <tr>
      <td className="text-muted">{index}</td>
      {
        label === 'TOTAL USERS JOINED TODAY' ? (
          <td className={bold ? 'fw-semibold' : ''}>{label} <span className='text-primary'>(This Count is from all outlets)</span></td>
        ) : (
          <td className={bold ? 'fw-semibold' : ''}>{label}</td>
        )
      }
      <td className={`text-center ${textClass} ${bold ? 'fw-semibold' : ''}`}>
        {value}
      </td>
    </tr>
  );
};

export default DaySummaryReport;